/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class HealthService {
    /**
     * Health check
     * Get basic health status
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getHealth(): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/health',
        });
    }
    /**
     * Detailed health check
     * Get detailed health status including dependencies
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getDetailedHealth(): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/health/detailed',
        });
    }
    /**
     * Readiness check
     * Kubernetes readiness probe endpoint
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getReadiness(): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/health/ready',
        });
    }
}
